import { render, staticRenderFns } from "./DictionaryDetail.vue?vue&type=template&id=6a90089a&"
import script from "./DictionaryDetail.vue?vue&type=script&lang=js&"
export * from "./DictionaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports